import './assets/css/error.scss'
import Lottie from 'react-lottie';
import loadingAnimation from '../../assets/images/error.json'
import {NavLink, useLocation, useNavigate, useParams} from "react-router-dom";
import useCountDown from "../../utility/useCountDown";
import {useEffect, useState} from "react";
import AppSettingController from "../Main/controller/AppSettingController";
import MarketSetting from "../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";
import {withLang} from "../../routes/LangLayout";

export default function Error() {
    const {t} = useTranslation();
    const location = useLocation();
    const {errorMessage} = location.state || {};
    const setting = AppSettingController.getSetting() as MarketSetting;
    const count = useCountDown(13);
    const navigate = useNavigate();
    const {shopId, lang} = useParams();
    const textErrorWithPos = t("error.posFailed");
    const textErrorWithCash = t("error.cashFailed");
    const [title, setTitle] = useState(textErrorWithPos)

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingAnimation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    useEffect(() => {
        if (!count) {
            navigate(withLang(`/${shopId}`, lang), {replace: true});
        }
    }, [count, lang, navigate, shopId]);

    useEffect(() => {
        if (AppSettingController.isActivePayment())
            setTitle(textErrorWithCash)
        if (setting.marketMode === 'pos-or-cash')
            setTitle(setting.paymentMode === 'pos' ? textErrorWithPos : textErrorWithCash)
    }, [textErrorWithCash, textErrorWithPos, setting.marketMode, setting.paymentMode]);

    return (
        <section className={'error-container'}>
            <div className={'content'}>
                <div className="logo">
                    <Lottie
                        options={defaultOptions}
                        isClickToPauseDisabled
                        height={120}
                        width={120}
                    />
                </div>
                <div className={'title'}>
                    <h1>{title}</h1>
                    {errorMessage ? <span>{errorMessage}</span> : null}
                </div>
                <div className="footer">
                    <NavLink to={withLang(`/${shopId}`, lang)}>{t("back")}</NavLink>
                    <p>{t("error.autoRedirect", { count })}</p>
                </div>
            </div>
        </section>
    )
}
